import { render } from "./multi-component-loader.vue?vue&type=template&id=11ca6a3e&scoped=true"
import script from "./multi-component-loader.vue?vue&type=script&lang=js"
export * from "./multi-component-loader.vue?vue&type=script&lang=js"

import "./multi-component-loader.vue?vue&type=style&index=0&id=11ca6a3e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11ca6a3e"]])

export default __exports__